import React from "react";
import Head from "next/head";
import { Helmet } from "react-helmet";
import LayoutBasic from "../layouts/layoutBasic";
import { BOOK_PHOTOGRAPHER, GET_USER_URL, TOKEN } from "../vars";
import { getLocalKeyValue } from "../storage";
import { withRouter } from "next/router";
import Link from 'next/link'
import { SeoMetaBookPhotographer } from "../components/seoMeta";
import LicenseNotice from "../components/LicenseNotice";

class book_photographer extends React.Component {
    constructor(props) {
        super();
        this.state = {
            name: "",
            mobile: "",
            email: "",
            city: "",
            cities: [
                'Ahmedabad',
                'Bengaluru',
                'Chennai',
                'Guntur',
                'Hyderabad',
                'Jamnagar',
                'Jaipur',
                'Kolkata',
                'Mumbai',
                'Surat',
                'Thrissur',
                'Vijayawada',
                'Visakhapatnam'
            ],
            eventType: "",
            eventDate: "",
            details: "",
            errors: {},
            successMessage: '',
            errorMessage: '',
        };
    }



    static async getInitialProps(props) {
        let token = (await process.browser)
            ? getLocalKeyValue(TOKEN)
            : props.query.sec_token;
        let infoRequest,
            infoResponse = {};

        if (token) {
            try {
                infoRequest = await GET(GET_USER_URL, token);
                infoResponse = await infoRequest.data;
            } catch (e) { }
        }

        return {
            token: token,
            user: infoResponse.user,
            cart: infoResponse.cart,
            // pagination: {
            //     page: data.page,
            //     total_pages: data.total_pages
            // },
        };
    }

    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
        });
    };

    handleBlur = (e) => {
        this.setState({
            errors: {
                ...this.state.errors,
                [e.target.name]: '', // Clear specific field error on blur
            },
        });
    };

    validateForm = () => {
        const { name, email, mobile, city, eventType, eventDate } = this.state;
        const errors = {};

        // Name validation
        if (!name) {
            errors.name = 'Name is required';
        }

        // Email validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!email) {
            errors.email = 'Email is required';
        } else if (!emailRegex.test(email)) {
            errors.email = 'Invalid email address';
        }

        // Mobile validation (only numbers and at least 10 digits)
        const mobileRegex = /^[0-9]{10}$/;
        if (!mobile) {
            errors.mobile = 'Mobile number is required';
        } else if (!mobileRegex.test(mobile)) {
            errors.mobile = 'Invalid mobile number (must be 10 digits)';
        }

        // City validation
        if (!city) {
            errors.city = 'City is required';
        }

        // Event type validation
        if (!eventType) {
            errors.eventType = 'Event type is required';
        }

        // Event date validation
        if (!eventDate) {
            errors.eventDate = 'Event date is required';
        }

        // Set errors in state
        this.setState({ errors });

        // Return true if there are no errors, otherwise false
        return Object.keys(errors).length === 0;
    };

    handleSubmit = (e) => {
        e.preventDefault();
        // You can handle the form submission here
        let data = {
            name: this.state.name,
            email: this.state.email,
            mobile: this.state.mobile,
            event_type: this.state.eventType,
            event_date: this.state.eventDate,
            detail: this.state.details,
            city: this.state.city
        }



        // Validate the form
        if (this.validateForm()) {
            // If the form is valid, submit the data (e.g., send to the server or email)


            fetch(BOOK_PHOTOGRAPHER, {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json",
                    //'Authorization': 'Token ' + getLocalKeyValue(TOKEN)
                },
                body: JSON.stringify(data)
            }
            ).then(res => res.json())
                .then((response) => {
                    if (response.status === true) {
                        this.setState({
                            successMessage: 'Form submitted successfully! Please check your email for more information.',
                            errorMessage: '', // Clear the error message,
                            name: "",
                            mobile: "",
                            email: "",
                            city: "",
                            eventType: "",
                            eventDate: "",
                            details: ""
                        });

                        setTimeout(() => {
                            this.setState({ successMessage: '' });
                            window.location.href = "/acknowledgment";
                        }, 2000);

                    }
                    else {
                        this.setState({ error: true })
                        this.setState({
                            errorMessage: 'There was an issue submitting the form. Please try again.',
                            successMessage: '', // Clear the success message
                        });
                        setTimeout(() => {
                            this.setState({ errorMessage: '' });
                        }, 2000);
                    }


                }).catch((err) => {
                    this.setState({
                        errorMessage: 'Something went wrong. Please try again later.',
                        successMessage: '', // Clear the success message
                    });
                    console.error("error", err.message)
                    setTimeout(() => {
                        this.setState({ errorMessage: '' });
                    }, 2000);
                })
        } else {
            console.log('Form contains errors.');
        }

    };




    componentDidMount() {
        // Initialize the OwlCarousel



        this.initializeOwlCarousel = () => {
            if (typeof window !== 'undefined' && typeof $ !== 'undefined') {
                $("#photgraphers-slider").owlCarousel({
                    loop: true,
                    margin: 10,
                    nav: true,
                    autoplay: true,
                    autoplayTimeout: 3000,
                    autoplayHoverPause: true,
                    responsive: {
                        0: {
                            items: 1, // 1 item for mobile
                        },
                        600: {
                            items: 2, // You can adjust this if you want more items between mobile and desktop
                        },
                        1000: {
                            items: 4, // 4 items for desktop
                        },
                    },
                });


            } else {

                console.error('jQuery or Owl Carousel not loaded');
            }
        };

        if (typeof window !== 'undefined') {
            // Check if Owl Carousel is available
            const script = document.createElement('script');
            script.src = "https://cdnjs.cloudflare.com/ajax/libs/owl-carousel/1.3.3/owl.carousel.min.js";
            // script.onload = initializeOwlCarousel;
            script.onload = this.initializeOwlCarousel;
            //script.onload = this.initializeOwlCarousel_2;

            document.body.appendChild(script);
        }


        this.testimonial = () => {
            if (typeof window !== 'undefined' && typeof $ !== 'undefined') {
                $("#testimonial-slider").owlCarousel({
                    items: 2,
                    pagination: false,
                    slideSpeed: 1000,
                    autoPlay: true,
                    nav: true,
                    dots: false,
                    responsive: {
                        0: {
                            items: 1
                        },
                        600: {
                            items: 1
                        },
                        1000: {
                            items: 1
                        }
                    }
                });
            } else {

                console.error('jQuery or Owl Carousel not loaded');
            }
        };


        if (typeof window !== 'undefined') {
            // Check if Owl Carousel is available
            const script = document.createElement('script');
            script.src = "https://cdnjs.cloudflare.com/ajax/libs/owl-carousel/1.3.3/owl.carousel.min.js";
            // script.onload = initializeOwlCarousel;
            // script.onload = this.initializeOwlCarousel_2;
            script.onload = this.testimonial;

            document.body.appendChild(script);
        }


        this.Carousel2 = () => {
            if (typeof window !== 'undefined' && typeof $ !== 'undefined') {
                $("#clients-slider").owlCarousel({
                    items: 1,
                    itemsDesktop: [1000, 2],
                    itemsDesktopSmall: [990, 2],
                    itemsTablet: [768, 1],
                    pagination: true,
                    navigation: false,
                    navigationText: ["", ""],
                    slideSpeed: 1000,
                    autoPlay: true
                });
            }
        }


        if (typeof window !== 'undefined') {
            // Check if Owl Carousel is available
            const script = document.createElement('script');
            script.src = "https://cdnjs.cloudflare.com/ajax/libs/owl-carousel/1.3.3/owl.carousel.min.js";
            // script.onload = initializeOwlCarousel;
            // script.onload = this.initializeOwlCarousel_2;
            script.onload = this.Carousel2;

            document.body.appendChild(script);
        }



    }


    render() {
        const { errors } = this.state;
        let title = "Professional Event Photography Services | Picxy"
        return <LayoutBasic title={title} {...this.props} navSearchBtn={'no'} defaultNavBar={true}>
            <SeoMetaBookPhotographer {...this.props} />
            <LicenseNotice />

            <>
                <Helmet>
                    <title>Professional Event Photography Services | Picxy</title>
                    <meta
                        property="og:title"
                        content="Be Present at Your Event. We'll Preserve Every Memory."
                    />
                    <meta
                        property="og:description"
                        content="Trusted photographers, effortless coordination, and memories you'll cherish for years to come."
                    />
                    <meta
                        property="og:image"
                        content="https://dev.picxy.com/static/imgv1/book-photographer.webp"
                    />
                    <link
                        href="https://fonts.googleapis.com/css2?family=Bebas+Neue&family=DM+Sans:ital,wght@0,300;0,400;0,500;0,700;1,300&family=Space+Mono:wght@400;700&display=swap"
                        rel="stylesheet"
                    />
                </Helmet>

                <div className="dark-theme-photographer">

                {/* Banner Section Starts here */}
                <section className="photography-banner">
                    <div className="container-fluid py-3">
                        <div className="row">
                            <div className="col-lg-8 col-md-12 col-sm-12 bannerbox">
                                <h1 className="mb-4 title">
                                    India's Leading <br /><span className="accent-word">Photographer</span><br /> <em>Booking Platform</em>
                                </h1>
                                <div className="row m-0 justify-content-center justify-content-md-start">
                                    <div className="col-lg-4 col-md-4 col-sm-12 objects py-3">
                                        <img
                                            src="../static/img/cam-icon-white.svg"
                                            alt="photography"
                                            className="img-fluid d-block mx-auto mb-2"
                                        />
                                        <h6 className="text">Corporate Photoshoots</h6>
                                    </div>
                                    <div className="col-lg-4 col-md-4 col-sm-12 objects py-3">
                                        <img
                                            src="../static/img/cam-icon-white.svg"
                                            alt="photography"
                                            className="img-fluid d-block mx-auto mb-2"
                                        />
                                        <h6 className="text">Public Event Coverage</h6>
                                    </div>
                                    <div className="col-lg-4 col-md-4 col-sm-12 objects py-3">
                                        <img
                                            src="../static/img/cam-icon-white.svg"
                                            alt="photography"
                                            className="img-fluid d-block mx-auto mb-2"
                                        />
                                        <h6 className="text">Personal Photoshoots</h6>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-12 col-sm-12 form">
                                <p className="form_head p-3">Book Your Photographer</p>
                                <form onSubmit={this.handleSubmit} noValidate>
                                    <div className="row pt-2 px-2 form_box">
                                        <div className="col-sm-6 form_field">
                                            <div className="form-group">
                                                <label
                                                    className="form_label pb-2"
                                                    id="name-label"
                                                    htmlFor="city"
                                                >
                                                    City
                                                </label>
                                                <select
                                                    name="city"
                                                    id="city"
                                                    className={`form-select ${errors.city ? 'is-invalid' : ''}`}
                                                    value={this.state.city}
                                                    onChange={this.handleChange}
                                                    onFocus={this.handleBlur}
                                                    required
                                                >
                                                    <option value="">Select City</option>
                                                    {this.state.cities.map((city, index) => (
                                                        <option key={index} value={city}>
                                                            {city}
                                                        </option>
                                                    ))}
                                                    <option value="Other">Other</option> {/* Adding the 'Other' option */}
                                                </select>
                                                {errors.city && <div className="invalid-feedback">{errors.city}</div>}
                                            </div>
                                        </div>

                                        <div className="col-sm-6 form_field">
                                            <div className="form-group">
                                                <label className="form_label pb-2">Event Type</label>
                                                <select
                                                    className={`form-select ${errors.eventType ? 'is-invalid' : ''}`}
                                                    name="eventType"
                                                    value={this.state.eventType}
                                                    onChange={this.handleChange}
                                                    onFocus={this.handleBlur}
                                                    required
                                                >
                                                    <option value="">Select</option>
                                                    <option value="Engagement">Engagement</option>
                                                    <option value="Pre-Wedding">Pre-Wedding</option>
                                                    <option value="Wedding">Wedding</option>
                                                    <option value="New Born">New Born</option>
                                                    <option value="Maternity">Maternity</option>
                                                    <option value="Corporate Events">Corporate Events</option>
                                                    <option value="Commerical/Ads">Commerical/Ads</option>
                                                    <option value="Portfolio">Portfolio</option>
                                                    <option value="Conference">Conference</option>
                                                    <option value="Public Events">Public Events</option>
                                                    <option value="Sports">Sports</option>
                                                    <option value="Live Streaming">Live Streaming</option>
                                                    <option value="Celebrity Events">Celebrity Events</option>
                                                </select>
                                                {errors.eventType && <div className="invalid-feedback">{errors.eventType}</div>}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row pt-2 px-2 form_box">
                                        <div className="col-sm-6 form_field">
                                            <div className="form-group">
                                                <label
                                                    id="date-label"
                                                    className="form_label pb-2"
                                                    htmlFor="date"
                                                >
                                                    Event Date
                                                </label>
                                                <input
                                                    type="date"
                                                    name="eventDate"
                                                    id="date"
                                                    className={`form-control ${errors.eventDate ? 'is-invalid' : ''}`}
                                                    value={this.state.eventDate}
                                                    onChange={this.handleChange}
                                                    onFocus={this.handleBlur}
                                                    min={new Date().toISOString().split('T')[0]} // Disable past dates
                                                    required
                                                />
                                                {errors.eventDate && <div className="invalid-feedback">{errors.eventDate}</div>}
                                            </div>
                                        </div>
                                        <div className="col-sm-6 form_field">
                                            <div className="form-group">
                                                <label
                                                    id="name-label pb-2"
                                                    className="form_label pb-2"
                                                    htmlFor="name"
                                                >
                                                    Name
                                                </label>
                                                <input
                                                    type="text"
                                                    name="name"
                                                    id="name"
                                                    className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                                                    value={this.state.name}
                                                    onChange={this.handleChange}
                                                    onFocus={this.handleBlur}
                                                    required
                                                />
                                                {errors.name && <div className="invalid-feedback">{errors.name}</div>}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row pt-2 px-2 form_box">
                                        <div className="col-sm-6 form_field">
                                            <div className="form-group">
                                                <label
                                                    id="mobile-label pb-2"
                                                    className="form_label pb-2"
                                                    htmlFor="mobile"
                                                >
                                                    Mobile
                                                </label>
                                                <input
                                                    type="tel"
                                                    name="mobile"
                                                    id="mobile"
                                                    className={`form-control ${errors.mobile ? 'is-invalid' : ''}`}
                                                    value={this.state.mobile}
                                                    onChange={this.handleChange}
                                                    onFocus={this.handleBlur}
                                                    required
                                                />
                                                {errors.mobile && <div className="invalid-feedback">{errors.mobile}</div>}
                                            </div>
                                        </div>
                                        <div className="col-sm-6 form_field">
                                            <div className="form-group">
                                                <label
                                                    className="form_label pb-2"
                                                    id="email-label"
                                                    htmlFor="email"
                                                >
                                                    Email
                                                </label>
                                                <input
                                                    type="email"
                                                    name="email"
                                                    id="email"
                                                    className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                                                    value={this.state.email}
                                                    onChange={this.handleChange}
                                                    onFocus={this.handleBlur}
                                                    required
                                                />
                                                {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                                            </div>
                                        </div>
                                    </div>


                                    <div className="row pt-2 px-2 form_box">
                                        <div className="col-sm-12 col-lg-12 col-sm-12 px-1">
                                            <div className="form-group pb-3">
                                                <label className="form_label pb-2">Details</label>
                                                <textarea
                                                    rows="5"
                                                    id="details"
                                                    className="form-control"
                                                    name="details"
                                                    value={this.state.details}
                                                    onChange={this.handleChange}
                                                    onFocus={this.handleBlur}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-12 col-lg-12 col-sm-12">
                                            <button
                                                type="submit"
                                                id="submit"
                                                className="btn btn-primary btn-block form_footer p-3"
                                            >
                                                Let Us Know <i className="fas form_icon">&#xf061;</i>
                                            </button>
                                        </div>
                                    </div>
                                </form>


                                {/* Bootstrap Success Alert */}
                                {this.state.successMessage && (
                                    <div className="alert alert-success" role="alert">
                                        {this.state.successMessage}
                                    </div>
                                )}

                                {/* Bootstrap Error Alert */}
                                {this.state.errorMessage && (
                                    <div className="alert alert-danger" role="alert">
                                        {this.state.errorMessage}
                                    </div>
                                )}

                            </div>
                        </div>
                    </div>
                </section>
                {/* Banner Section Ends here */}
                {/* Additional sections go here */}

                {/* <!-- Tag section for desktop view --> */}
                <div className="tag d-none d-md-block d-lg-block p-0">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 px-4">
                                <p className="m-3">Affordable Pricing | Our packages start from just <span className="fixed-pricing">INR 3000/-</span></p>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <!-- Tag Section Ends here --> */}

                {/* <!-- AI Face Sync Section Starts here --> */}
                <section className="ai-face-sync-new">
                    <div className="container">
                    <div className="row">
                    <div className="col-lg-6 col-sm-12" id="image">
                        <img src="../static/img/facesync/ai-face-new.png" style={{ width: "100%", height: "525px", objectFit: "contain" }} />
                    </div>
                    <div className="col-lg-6 col-sm-12" id="text">
                        <h3 className="heading">AI-Face Sync</h3>
                        <h5 className="sub-heading">Experience the New Era of Photo Sharing</h5>
                        <p className="para">Capturing Personalized Moments for Your Guests with Advanced Face Recognition Technology</p>
                        <Link href='/ai_face_sync'><button className="btn-md">Read More</button></Link>
                    </div>
                    </div>
                    </div>
                    <div className="hero-grid"></div>
                </section>
                {/* <!-- AI Face Sync Section Ends here --> */}

                {/* <!-- Collection Section Starts here --> */}

                {/*<section className="collection">
                    <div className="container py-5">
                        <div className="row">
                            <div className="col-lg-3 col-md-12 col-sm-12 collection1">
                                <div className="subdiv_photo">
                                    <img src="../static/img/events.png"
                                        className="w-100 shadow-1-strong rounded imagesize1"
                                        alt="Events Photography - Capture special moments" />
                                    <p className="category px-3">Events Photography<span className="category_icon">&#8594;</span></p>
                                </div>
                                <div className="subdiv_photo">
                                    <img src="../static/img/corporate.png"
                                        className="w-100 shadow-1-strong rounded imagesize2"
                                        alt="Corporate Photography - Professional business shoots" />
                                    <p className="category px-3">Corporate Photography<span className="category_icon">&#8594;</span></p>
                                </div>
                            </div>

                            <div className="col-lg-6 col-md-12 col-sm-12 pt-3 collection2">
                                <h2 className="headh3 p-4 mb-4 text-center">A Collection Of Our Photoshoot Moments</h2>
                                <div className="row">
                                    <div className="col-lg-6 col-md-12 col-sm-12">
                                        <div className="subdiv_photo">
                                            <img src="../static/img/ads.png"
                                                className="w-100 shadow-1-strong rounded imagesize3"
                                                alt="Ads Shoot - Creative advertising photography" />
                                            <p className="category px-3">Ads Shoot<span className="category_icon">&#8594;</span></p>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-12 col-sm-12">
                                        <div className="subdiv_photo">
                                            <img src="../static/img/business.png"
                                                className="w-100 shadow-1-strong rounded imagesize3"
                                                alt="Business Meetings Shoot - Capturing key moments" />
                                            <p className="category px-3">Business Meetings Shoot<span className="category_icon">&#8594;</span></p>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-6 col-md-12 col-sm-12">
                                        <div className="subdiv_photo">
                                            <img src="../static/img/wedding.png"
                                                className="w-100 shadow-1-strong rounded imagesize4"
                                                alt="Wedding Photography - Timeless memories of your special day" />
                                            <p className="category px-3">Wedding Photography<span className="category_icon">&#8594;</span></p>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-12 col-sm-12">
                                        <div className="subdiv_photo">
                                            <img src="../static/img/sports.png"
                                                className="w-100 shadow-1-strong rounded imagesize4"
                                                alt="Sports Photography - Dynamic action shots" />
                                            <p className="category px-3">Sports Photography<span className="category_icon">&#8594;</span></p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-3 col-md-12 col-sm-12 collection3">
                                <div className="subdiv_photo">
                                    <img src="../static/img/concept.png"
                                        className="w-100 shadow-1-strong rounded imagesize1"
                                        alt="Concept Photography - Innovative and creative concepts" />
                                    <p className="category px-3">Concept Photography<span className="category_icon">&#8594;</span></p>
                                </div>
                                <div className="subdiv_photo">
                                    <img src="../static/img/kids.png"
                                        className="w-100 shadow-1-strong rounded imagesize2"
                                        alt="Kids Photography - Capturing the joy of childhood" />
                                    <p className="category px-3">Kids Photography<span className="category_icon">&#8594;</span></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section> */}
                {/* <!-- Collection Section Ends here --> */}

                {/* <!-- offerings Section Starts here --> */}
                <section className="offerings">
                    <div className="container py-5">
                        <div className="row">
                            <div className="col-12">
                                <h2 className="sub_heading">Our Custom Photoshoot Offerings</h2>
                                <p className="sub_text">
                                    Are you looking to capture moments that matter? Through the Picxy platform, we bring you professional custom photoshoot services, tailored to suit a wide range of occasions. With a vibrant community of over 2 million photographers, we ensure you have access to the perfect talent for any event.
                                </p>
                            </div>
                        </div>

                        <ul className="nav nav-tabs book-photographer-tabs pt-3" id="myTab" role="tablist">
                            <li className="nav-item">
                                <a className="nav-link active tab_content d-flex align-items-center" id="Corporate-tab" data-toggle="tab" href="#Corporate" role="tab" aria-controls="Corporate" aria-selected="true">
                                    <svg width="31" height="42" viewBox="0 0 31 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M26.8 4.16H24.65C24.27 4.16 23.93 3.93 23.79 3.58L22.91 1.63C22.46 0.64 21.47 0 20.39 0H15.65C14.56 0 13.57 0.64 13.13 1.63L12.25 3.58C12.11 3.93 11.77 4.16 11.39 4.16H9.03C8.87 4.16 8.73 4.08 8.64 3.95L8.13 3.18C7.96 2.92 7.67 2.77 7.36 2.77H5.58C5.27 2.77 4.98 2.92 4.81 3.18L4.3 3.95C4.21 4.08 4.07 4.16 3.91 4.16H3.23C1.44 4.16 0 5.61 0 7.4V23.57C0 25.36 1.45 26.8 3.23 26.8H26.8C28.59 26.8 30.04 25.35 30.04 23.57V7.39C30.04 5.6 28.59 4.15 26.8 4.15V4.16ZM9.47 9.7C8.83 9.7 8.31 9.18 8.31 8.54C8.31 7.9 8.83 7.39 9.47 7.39C10.11 7.39 10.63 7.91 10.63 8.54C10.63 9.17 10.11 9.7 9.47 9.7ZM17.79 22.64C13.83 22.64 10.63 19.43 10.63 15.48C10.63 11.53 13.84 8.32 17.79 8.32C21.74 8.32 24.95 11.53 24.95 15.48C24.95 19.43 21.74 22.64 17.79 22.64ZM12.02 15.94C11.76 15.94 11.56 15.73 11.56 15.48C11.56 12.04 14.36 9.24 17.8 9.24C18.06 9.24 18.26 9.45 18.26 9.7C18.26 9.95 18.05 10.16 17.8 10.16C14.87 10.16 12.49 12.54 12.49 15.47C12.49 15.73 12.28 15.93 12.03 15.93L12.02 15.94ZM25.27 41.06C25.05 41.26 24.77 41.36 24.49 41.36C24.18 41.36 23.87 41.24 23.64 40.98L16.17 32.84V38.82C16.17 39.46 15.65 39.98 15.01 39.98C14.37 39.98 13.85 39.46 13.85 38.82V32.84L6.38 40.98C6.15 41.23 5.84 41.36 5.53 41.36C5.25 41.36 4.97 41.26 4.75 41.06C4.28 40.63 4.25 39.9 4.68 39.43L13.28 30.04H11.33C11.17 30.04 11.02 29.95 10.93 29.82L10.1 28.43C9.92 28.12 10.14 27.73 10.5 27.73H19.5C19.86 27.73 20.08 28.12 19.9 28.43L19.07 29.82C18.99 29.96 18.84 30.04 18.67 30.04H16.72L25.32 39.43C25.75 39.9 25.72 40.63 25.25 41.06H25.27Z" fill="#2F3293" />
                                    </svg>

                                    <span className="tab-text">Corporate Photoshoots</span>
                                </a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link tab_content d-flex align-items-center" id="public-tab" data-toggle="tab" href="#public" role="tab" aria-controls="public" aria-selected="false">
                                    <svg width="31" height="42" viewBox="0 0 31 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M26.8 4.16H24.65C24.27 4.16 23.93 3.93 23.79 3.58L22.91 1.63C22.46 0.64 21.47 0 20.39 0H15.65C14.56 0 13.57 0.64 13.13 1.63L12.25 3.58C12.11 3.93 11.77 4.16 11.39 4.16H9.03C8.87 4.16 8.73 4.08 8.64 3.95L8.13 3.18C7.96 2.92 7.67 2.77 7.36 2.77H5.58C5.27 2.77 4.98 2.92 4.81 3.18L4.3 3.95C4.21 4.08 4.07 4.16 3.91 4.16H3.23C1.44 4.16 0 5.61 0 7.4V23.57C0 25.36 1.45 26.8 3.23 26.8H26.8C28.59 26.8 30.04 25.35 30.04 23.57V7.39C30.04 5.6 28.59 4.15 26.8 4.15V4.16ZM9.47 9.7C8.83 9.7 8.31 9.18 8.31 8.54C8.31 7.9 8.83 7.39 9.47 7.39C10.11 7.39 10.63 7.91 10.63 8.54C10.63 9.17 10.11 9.7 9.47 9.7ZM17.79 22.64C13.83 22.64 10.63 19.43 10.63 15.48C10.63 11.53 13.84 8.32 17.79 8.32C21.74 8.32 24.95 11.53 24.95 15.48C24.95 19.43 21.74 22.64 17.79 22.64ZM12.02 15.94C11.76 15.94 11.56 15.73 11.56 15.48C11.56 12.04 14.36 9.24 17.8 9.24C18.06 9.24 18.26 9.45 18.26 9.7C18.26 9.95 18.05 10.16 17.8 10.16C14.87 10.16 12.49 12.54 12.49 15.47C12.49 15.73 12.28 15.93 12.03 15.93L12.02 15.94ZM25.27 41.06C25.05 41.26 24.77 41.36 24.49 41.36C24.18 41.36 23.87 41.24 23.64 40.98L16.17 32.84V38.82C16.17 39.46 15.65 39.98 15.01 39.98C14.37 39.98 13.85 39.46 13.85 38.82V32.84L6.38 40.98C6.15 41.23 5.84 41.36 5.53 41.36C5.25 41.36 4.97 41.26 4.75 41.06C4.28 40.63 4.25 39.9 4.68 39.43L13.28 30.04H11.33C11.17 30.04 11.02 29.95 10.93 29.82L10.1 28.43C9.92 28.12 10.14 27.73 10.5 27.73H19.5C19.86 27.73 20.08 28.12 19.9 28.43L19.07 29.82C18.99 29.96 18.84 30.04 18.67 30.04H16.72L25.32 39.43C25.75 39.9 25.72 40.63 25.25 41.06H25.27Z" fill="#2F3293" />
                                    </svg>

                                    <span className="tab-text">Public Event Coverage</span>
                                </a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link tab_content d-flex align-items-center" id="personal-tab" data-toggle="tab" href="#personal" role="tab" aria-controls="personal" aria-selected="false">
                                    <svg width="31" height="42" viewBox="0 0 31 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M26.8 4.16H24.65C24.27 4.16 23.93 3.93 23.79 3.58L22.91 1.63C22.46 0.64 21.47 0 20.39 0H15.65C14.56 0 13.57 0.64 13.13 1.63L12.25 3.58C12.11 3.93 11.77 4.16 11.39 4.16H9.03C8.87 4.16 8.73 4.08 8.64 3.95L8.13 3.18C7.96 2.92 7.67 2.77 7.36 2.77H5.58C5.27 2.77 4.98 2.92 4.81 3.18L4.3 3.95C4.21 4.08 4.07 4.16 3.91 4.16H3.23C1.44 4.16 0 5.61 0 7.4V23.57C0 25.36 1.45 26.8 3.23 26.8H26.8C28.59 26.8 30.04 25.35 30.04 23.57V7.39C30.04 5.6 28.59 4.15 26.8 4.15V4.16ZM9.47 9.7C8.83 9.7 8.31 9.18 8.31 8.54C8.31 7.9 8.83 7.39 9.47 7.39C10.11 7.39 10.63 7.91 10.63 8.54C10.63 9.17 10.11 9.7 9.47 9.7ZM17.79 22.64C13.83 22.64 10.63 19.43 10.63 15.48C10.63 11.53 13.84 8.32 17.79 8.32C21.74 8.32 24.95 11.53 24.95 15.48C24.95 19.43 21.74 22.64 17.79 22.64ZM12.02 15.94C11.76 15.94 11.56 15.73 11.56 15.48C11.56 12.04 14.36 9.24 17.8 9.24C18.06 9.24 18.26 9.45 18.26 9.7C18.26 9.95 18.05 10.16 17.8 10.16C14.87 10.16 12.49 12.54 12.49 15.47C12.49 15.73 12.28 15.93 12.03 15.93L12.02 15.94ZM25.27 41.06C25.05 41.26 24.77 41.36 24.49 41.36C24.18 41.36 23.87 41.24 23.64 40.98L16.17 32.84V38.82C16.17 39.46 15.65 39.98 15.01 39.98C14.37 39.98 13.85 39.46 13.85 38.82V32.84L6.38 40.98C6.15 41.23 5.84 41.36 5.53 41.36C5.25 41.36 4.97 41.26 4.75 41.06C4.28 40.63 4.25 39.9 4.68 39.43L13.28 30.04H11.33C11.17 30.04 11.02 29.95 10.93 29.82L10.1 28.43C9.92 28.12 10.14 27.73 10.5 27.73H19.5C19.86 27.73 20.08 28.12 19.9 28.43L19.07 29.82C18.99 29.96 18.84 30.04 18.67 30.04H16.72L25.32 39.43C25.75 39.9 25.72 40.63 25.25 41.06H25.27Z" fill="#2F3293" />
                                    </svg>

                                    <span className="tab-text">Personal Photoshoots</span>
                                </a>
                            </li>
                        </ul>

                        <div className="tab-content p-4" id="myTabContent">
                            <div className="tab-pane fade show active" id="Corporate" role="tabpanel" aria-labelledby="Corporate-tab">
                                <div className="row">
                                    <div className="col-lg-4 col-md-4 col-sm-12">
                                        <img src="../static/img/offerings/commercial-ad.png" className="img-fluid" />
                                        <h5 className="tab_heading pt-2">Commercial<br />Ads</h5>
                                    </div>
                                    <div className="col-lg-4 col-md-4 col-sm-12">
                                        <img src="../static/img/offerings/portfoli-dev.png" className="img-fluid" />
                                        <h5 className="tab_heading pt-2">Portfolio<br />Development</h5>
                                    </div>
                                    <div className="col-lg-4 col-md-4 col-sm-12">
                                        <img src="../static/img/offerings/conferences.png" className="img-fluid" />
                                        <h5 className="tab_heading pt-2">Conferences & <br /> Corporate Events</h5>
                                    </div>
                                </div>
                            </div>

                            <div className="tab-pane fade show" id="public" role="tabpanel" aria-labelledby="public-tab">
                                <div className="row">
                                    <div className="col-lg-4 col-md-4 col-sm-12">
                                        <img src="../static/img/offerings/live-streming.png" className="img-fluid" />
                                        <h5 className="tab_heading pt-2">Live Streaming<br />of Open Events</h5>
                                    </div>
                                    <div className="col-lg-4 col-md-4 col-sm-12">
                                        <img src="../static/img/offerings/marathan.png" className="img-fluid" />
                                        <h5 className="tab_heading pt-2">Marathons<br />& Sports Events</h5>
                                    </div>
                                    <div className="col-lg-4 col-md-4 col-sm-12">
                                        <img src="../static/img/offerings/celebrity.png" className="img-fluid" />
                                        <h5 className="tab_heading pt-2">Celebrity<br />Events</h5>
                                    </div>
                                </div>
                            </div>

                            <div className="tab-pane fade" id="personal" role="tabpanel" aria-labelledby="personal-tab">
                                <div className="row">
                                    <div className="col-lg-4 col-md-4 col-sm-12">
                                        <img src="../static/img/offerings/personal-branding.png" className="img-fluid" />
                                        <h5 className="tab_heading pt-2">Personal<br />Branding</h5>
                                    </div>
                                    <div className="col-lg-4 col-md-4 col-sm-12">
                                        <img src="../static/img/offerings/engagement.png" className="img-fluid" />
                                        <h5 className="tab_heading pt-2">Engagement,<br />Pre-Wedding & Wedding</h5>
                                    </div>
                                    <div className="col-lg-4 col-md-4 col-sm-12">
                                        <img src="../static/img/offerings/newborn.png" className="img-fluid" />
                                        <h5 className="tab_heading pt-2">Newborn<br />& Maternity</h5>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="banner-strip" id="bannerStrip" style={{ margin: '0 60px'}}>
                            <div className="banner-text">
                                <strong>Not sure which step to take next?</strong><br />
                                <span>Our team will guide you through the entire AI-Face Sync journey.</span>
                            </div>
                            <div className="banner-actions">
                                <button className="banner-btn" id="btn4"  onClick={() => window.open("https://api.whatsapp.com/send?phone=918885558235", "_blank")}>✦ Get Assistance ✦</button>
                            </div>
                        </div>

                    </div>
                </section>
                {/* <!-- offerings Section Ends here --> */}
                {/* <!-- why picxy Section Starts here --> */}
                <section className="whypicxy">
                    <div className="container py-5">
                        <div className="row">
                            <div className="col-12">
                                <h2 className="sub_heading">Why Picxy?</h2>
                                <p className="sub_text">
                                    At Picxy, we connects you with verified, local professionals for every occasion—whether it’s Corporate events, Public events or Personal photoshoots. we ensure every moment is captured with precision and creativity. When you choose Picxy, you’re choosing quality, convenience, and outstanding results every time.
                                </p>
                            </div>
                        </div>

                        <div className="row badgetrow mt-5">
                            <div className="col-lg-2 col-md-4 col-sm-12 badgets pt-3 mb-3">
                                <p className="badgetnum">1</p>
                                <img src="../static/img/Vector.svg" alt="Access to photographers" className="img-fluid pb-3" />
                                <h6 className="badgettext">Access to 2+ million photographers</h6>
                            </div>

                            <div className="col-lg-2 col-md-4 col-sm-12 badgets pt-3 mb-3">
                                <p className="badgetnum">2</p>
                                <img src="../static/img/Vector.svg" alt="Expertise in events" className="img-fluid pb-3" />
                                <h6 className="badgettext">Expertise across various event types</h6>
                            </div>

                            <div className="col-lg-2 col-md-4 col-sm-12 badgets pt-3 mb-3">
                                <p className="badgetnum">3</p>
                                <img src="../static/img/Vector.svg" alt="Affordable photography" className="img-fluid pb-3" />
                                <h6 className="badgettext">Affordable, professional photography</h6>
                            </div>

                            <div className="col-lg-2 col-md-4 col-sm-12 badgets pt-3 mb-3">
                                <p className="badgetnum">4</p>
                                <img src="../static/img/Vector.svg" alt="High-quality delivery" className="img-fluid pb-3" />
                                <h6 className="badgettext">High-quality delivery, customized to your needs</h6>
                            </div>
                        </div>
                    </div>
                </section>
                {/* <!-- why picxy Section Ends here --> */}

                {/* <!-- Experts Section Starts here --> */}
                <section className="experts">
                    <div className="container py-5">
                        <div className="row">
                            <div className="col-12">
                                <h2 className="sub_heading">Our Featured Photography Experts</h2>
                                <p className="sub_text pb-4">
                                    Are you looking to capture moments that matter? Through the Picxy platform, we bring you professional custom photoshoot services, tailored to suit a wide range of occasions. With a vibrant community of over 2 million photographers, we ensure you have access to the perfect talent for any event.
                                </p>
                                <div id="photgraphers-slider" className="row sliderflipbox owl-carousel">
                                    <div className="expert-item">
                                        <div className="square-flip">
                                            <div className='square'>
                                                <div className="flipbox-container front">
                                                    <img src="../static/img/photgraphers/1.webp" className="boxshadow img-fluid" alt="" />
                                                </div>
                                            </div>
                                            <div className='square2'>
                                                <div className="flipbox-containerback">
                                                    <div className="row pt-2">
                                                        <div className="col-8">
                                                            <span className="flip-head">22510</span>
                                                            <p className="flip-text">Photos</p>
                                                        </div>
                                                        <div className="col-4">
                                                            <img src="../static/img/camera.png" id="flip_icon" />
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-8">
                                                            <span className="flip-head">883</span>
                                                            <p className="flip-text">Likes</p>
                                                        </div>
                                                        <div className="col-4">
                                                            <img src="../static/img/feedback.png" id="flip_icon" />
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-8">
                                                            <span className="flip-head">254600</span>
                                                            <p className="flip-text">Views</p>
                                                        </div>
                                                        <div className="col-4">
                                                            <img src="../static/img/eye.png" id="flip_icon" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <h2 className="pt-4 name">Abdul Munaff</h2>
                                        <h3 className="location">Hyderabad</h3>
                                    </div>

                                    <div className="expert-item">
                                        <div className="square-flip">
                                            <div className='square'>
                                                <div className="flipbox-container front">
                                                    <img src="../static/img/photgraphers/2.webp" className="boxshadow img-fluid" alt="" />
                                                </div>
                                            </div>
                                            <div className='square2'>
                                                <div className="flipbox-containerback">
                                                    <div className="row pt-2">
                                                        <div className="col-8">
                                                            <span className="flip-head">5202</span>
                                                            <p className="flip-text">Photos</p>
                                                        </div>
                                                        <div className="col-4">
                                                            <img src="../static/img/camera.png" id="flip_icon" />
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-8">
                                                            <span className="flip-head">44</span>
                                                            <p className="flip-text">Likes</p>
                                                        </div>
                                                        <div className="col-4">
                                                            <img src="../static/img/feedback.png" id="flip_icon" />
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-8">
                                                            <span className="flip-head">14902</span>
                                                            <p className="flip-text">Views</p>
                                                        </div>
                                                        <div className="col-4">
                                                            <img src="../static/img/eye.png" id="flip_icon" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <h2 className="pt-4 name">Idrees Mohammed</h2>
                                        <h3 className="location">Vijayawada</h3>
                                    </div>

                                    <div className="expert-item">
                                        <div className="square-flip">
                                            <div className='square'>
                                                <div className="flipbox-container front">
                                                    <img src="../static/img/photgraphers/10.webp" className="boxshadow img-fluid" alt="" />
                                                </div>
                                            </div>
                                            <div className='square2'>
                                                <div className="flipbox-containerback">
                                                    <div className="row pt-2">
                                                        <div className="col-8">
                                                            <span className="flip-head">3958</span>
                                                            <p className="flip-text">Photos</p>
                                                        </div>
                                                        <div className="col-4">
                                                            <img src="../static/img/camera.png" id="flip_icon" />
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-8">
                                                            <span className="flip-head">12</span>
                                                            <p className="flip-text">Likes</p>
                                                        </div>
                                                        <div className="col-4">
                                                            <img src="../static/img/feedback.png" id="flip_icon" />
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-8">
                                                            <span className="flip-head">1194</span>
                                                            <p className="flip-text">Views</p>
                                                        </div>
                                                        <div className="col-4">
                                                            <img src="../static/img/eye.png" id="flip_icon" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <h2 className="pt-4 name">Aala Images</h2>
                                        <h3 className="location">Kerala</h3>
                                    </div>

                                    <div className="expert-item">
                                        <div className="square-flip">
                                            <div className='square'>
                                                <div className="flipbox-container front">
                                                    <img src="../static/img/photgraphers/11.webp" className="boxshadow img-fluid" alt="" />
                                                </div>
                                            </div>
                                            <div className='square2'>
                                                <div className="flipbox-containerback">
                                                    <div className="row pt-2">
                                                        <div className="col-8">
                                                            <span className="flip-head">1582</span>
                                                            <p className="flip-text">Photos</p>
                                                        </div>
                                                        <div className="col-4">
                                                            <img src="../static/img/camera.png" id="flip_icon" />
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-8">
                                                            <span className="flip-head">28</span>
                                                            <p className="flip-text">Likes</p>
                                                        </div>
                                                        <div className="col-4">
                                                            <img src="../static/img/feedback.png" id="flip_icon" />
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-8">
                                                            <span className="flip-head">9268</span>
                                                            <p className="flip-text">Views</p>
                                                        </div>
                                                        <div className="col-4">
                                                            <img src="../static/img/eye.png" id="flip_icon" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <h2 className="pt-4 name">Dimpy Gogoi</h2>
                                        <h3 className="location">Nazira</h3>
                                    </div>

                                    <div className="expert-item">
                                        <div className="square-flip">
                                            <div className='square'>
                                                <div className="flipbox-container front">
                                                    <img src="../static/img/photgraphers/9.webp" className="boxshadow img-fluid" alt="" />
                                                </div>
                                            </div>
                                            <div className='square2'>
                                                <div className="flipbox-containerback">
                                                    <div className="row pt-2">
                                                        <div className="col-8">
                                                            <span className="flip-head">1258</span>
                                                            <p className="flip-text">Photos</p>
                                                        </div>
                                                        <div className="col-4">
                                                            <img src="../static/img/camera.png" id="flip_icon" />
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-8">
                                                            <span className="flip-head">20</span>
                                                            <p className="flip-text">Likes</p>
                                                        </div>
                                                        <div className="col-4">
                                                            <img src="../static/img/feedback.png" id="flip_icon" />
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-8">
                                                            <span className="flip-head">1088</span>
                                                            <p className="flip-text">Views</p>
                                                        </div>
                                                        <div className="col-4">
                                                            <img src="../static/img/eye.png" id="flip_icon" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <h2 className="pt-4 name">Soumen Hazra</h2>
                                        <h3 className="location">West Bengal</h3>
                                    </div>

                                    <div className="expert-item">
                                        <div className="square-flip">
                                            <div className='square'>
                                                <div className="flipbox-container front">
                                                    <img src="../static/img/photgraphers/8.webp" className="boxshadow img-fluid" alt="" />
                                                </div>
                                            </div>
                                            <div className='square2'>
                                                <div className="flipbox-containerback">
                                                    <div className="row pt-2">
                                                        <div className="col-8">
                                                            <span className="flip-head">444</span>
                                                            <p className="flip-text">Photos</p>
                                                        </div>
                                                        <div className="col-4">
                                                            <img src="../static/img/camera.png" id="flip_icon" />
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-8">
                                                            <span className="flip-head">11</span>
                                                            <p className="flip-text">Likes</p>
                                                        </div>
                                                        <div className="col-4">
                                                            <img src="../static/img/feedback.png" id="flip_icon" />
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-8">
                                                            <span className="flip-head">931</span>
                                                            <p className="flip-text">Views</p>
                                                        </div>
                                                        <div className="col-4">
                                                            <img src="../static/img/eye.png" id="flip_icon" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <h2 className="pt-4 name">Himani Singh</h2>
                                        <h3 className="location"></h3>
                                    </div>

                                    <div className="expert-item">
                                        <div className="square-flip">
                                            <div className='square'>
                                                <div className="flipbox-container front">
                                                    <img src="../static/img/photgraphers/3.webp" className="boxshadow img-fluid" alt="" />
                                                </div>
                                            </div>
                                            <div className='square2'>
                                                <div className="flipbox-containerback">
                                                    <div className="row pt-2">
                                                        <div className="col-8">
                                                            <span className="flip-head">430</span>
                                                            <p className="flip-text">Photos</p>
                                                        </div>
                                                        <div className="col-4">
                                                            <img src="../static/img/camera.png" id="flip_icon" />
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-8">
                                                            <span className="flip-head">4</span>
                                                            <p className="flip-text">Likes</p>
                                                        </div>
                                                        <div className="col-4">
                                                            <img src="../static/img/feedback.png" id="flip_icon" />
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-8">
                                                            <span className="flip-head">1874</span>
                                                            <p className="flip-text">Views</p>
                                                        </div>
                                                        <div className="col-4">
                                                            <img src="../static/img/eye.png" id="flip_icon" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <h2 className="pt-4 name">Dhanwanth Kumar</h2>
                                        <h3 className="location">Visakhapatnam</h3>
                                    </div>
                                   

                                    {/* <div className="expert-item">
                                        <div className="square-flip">
                                            <div className='square'>
                                                <div className="flipbox-container front">
                                                    <img src="../static/img/photgraphers/5.webp" className="boxshadow img-fluid" alt="" />
                                                </div>
                                            </div>
                                            <div className='square2'>
                                                <div className="flipbox-containerback">
                                                    <div className="row pt-2">
                                                        <div className="col-8">
                                                            <span className="flip-head">--</span>
                                                            <p className="flip-text">Photos</p>
                                                        </div>
                                                        <div className="col-4">
                                                            <img src="../static/img/camera.png" id="flip_icon" />
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-8">
                                                            <span className="flip-head">--</span>
                                                            <p className="flip-text">Likes</p>
                                                        </div>
                                                        <div className="col-4">
                                                            <img src="../static/img/feedback.png" id="flip_icon" />
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-8">
                                                            <span className="flip-head">--</span>
                                                            <p className="flip-text">Views</p>
                                                        </div>
                                                        <div className="col-4">
                                                            <img src="../static/img/eye.png" id="flip_icon" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <h2 className="pt-4 name">Prudhvi Koppaka</h2>
                                        <h3 className="location">Hyderabad</h3>
                                    </div> */}

                                    <div className="expert-item">
                                        <div className="square-flip">
                                            <div className='square'>
                                                <div className="flipbox-container front">
                                                    <img src="../static/img/photgraphers/6.webp" className="boxshadow img-fluid" alt="" />
                                                </div>
                                            </div>
                                            <div className='square2'>
                                                <div className="flipbox-containerback">
                                                    <div className="row pt-2">
                                                        <div className="col-8">
                                                            <span className="flip-head">362</span>
                                                            <p className="flip-text">Photos</p>
                                                        </div>
                                                        <div className="col-4">
                                                            <img src="../static/img/camera.png" id="flip_icon" />
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-8">
                                                            <span className="flip-head">17</span>
                                                            <p className="flip-text">Likes</p>
                                                        </div>
                                                        <div className="col-4">
                                                            <img src="../static/img/feedback.png" id="flip_icon" />
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-8">
                                                            <span className="flip-head">3251</span>
                                                            <p className="flip-text">Views</p>
                                                        </div>
                                                        <div className="col-4">
                                                            <img src="../static/img/eye.png" id="flip_icon" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <h2 className="pt-4 name">Sandeep Malempati</h2>
                                        <h3 className="location">Bengaluru</h3>
                                    </div>

                                    

                                    <div className="expert-item">
                                        <div className="square-flip">
                                            <div className='square'>
                                                <div className="flipbox-container front">
                                                    <img src="../static/img/photgraphers/7.webp" className="boxshadow img-fluid" alt="" />
                                                </div>
                                            </div>
                                            <div className='square2'>
                                                <div className="flipbox-containerback">
                                                    <div className="row pt-2">
                                                        <div className="col-8">
                                                            <span className="flip-head">172</span>
                                                            <p className="flip-text">Photos</p>
                                                        </div>
                                                        <div className="col-4">
                                                            <img src="../static/img/camera.png" id="flip_icon" />
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-8">
                                                            <span className="flip-head">2</span>
                                                            <p className="flip-text">Likes</p>
                                                        </div>
                                                        <div className="col-4">
                                                            <img src="../static/img/feedback.png" id="flip_icon" />
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-8">
                                                            <span className="flip-head">2201</span>
                                                            <p className="flip-text">Views</p>
                                                        </div>
                                                        <div className="col-4">
                                                            <img src="../static/img/eye.png" id="flip_icon" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <h2 className="pt-4 name">Vibhu Singh</h2>
                                        <h3 className="location">Lucknow</h3>
                                    </div>

                                    <div className="expert-item">
                                        <div className="square-flip">
                                            <div className='square'>
                                                <div className="flipbox-container front">
                                                    <img src="../static/img/photgraphers/4.webp" className="boxshadow img-fluid" alt="" />
                                                </div>
                                            </div>
                                            <div className='square2'>
                                                <div className="flipbox-containerback">
                                                    <div className="row pt-2">
                                                        <div className="col-8">
                                                            <span className="flip-head">49</span>
                                                            <p className="flip-text">Photos</p>
                                                        </div>
                                                        <div className="col-4">
                                                            <img src="../static/img/camera.png" id="flip_icon" />
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-8">
                                                            <span className="flip-head">10</span>
                                                            <p className="flip-text">Likes</p>
                                                        </div>
                                                        <div className="col-4">
                                                            <img src="../static/img/feedback.png" id="flip_icon" />
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-8">
                                                            <span className="flip-head">96</span>
                                                            <p className="flip-text">Views</p>
                                                        </div>
                                                        <div className="col-4">
                                                            <img src="../static/img/eye.png" id="flip_icon" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <h2 className="pt-4 name">Hardik Nagda</h2>
                                        <h3 className="location">Mumbai</h3>
                                    </div>


                                    {/* <div className="expert-item">
                                        <div className="square-flip">
                                            <div className='square'>
                                                <div className="flipbox-container front">
                                                    <img src="../static/img/testimonial4.png" className="boxshadow img-fluid" alt="" />
                                                </div>
                                            </div>
                                            <div className='square2'>
                                                <div className="flipbox-containerback">
                                                    <div className="row pt-2">
                                                        <div className="col-8">
                                                            <span className="flip-head">22510</span>
                                                            <p className="flip-text">Photos</p>
                                                        </div>
                                                        <div className="col-4">
                                                            <img src="../static/img/camera.png" id="flip_icon" />
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-8">
                                                            <span className="flip-head">883</span>
                                                            <p className="flip-text">Likes</p>
                                                        </div>
                                                        <div className="col-4">
                                                            <img src="../static/img/feedback.png" id="flip_icon" />
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-8">
                                                            <span className="flip-head">254600</span>
                                                            <p className="flip-text">Views</p>
                                                        </div>
                                                        <div className="col-4">
                                                            <img src="../static/img/eye.png" id="flip_icon" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <h2 className="pt-4 name">Hardik Nagda</h2>
                                        <h3 className="location">Mumbai</h3>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/* <!-- Experts Section Ends here --> */}

                <section className="container-fluid py-60 testimonials">
                    <div className="bg-column"></div>
                    <div className="row position-relative z-1">
                        <div className="col-xl-6 col-md-6 col-sm-12 test1 sectpad1 testimonial-content-block inner-testimonial">
                            <img src="../static/img_new/dots.png" className="dots" />
                            <h3 className="test1h3">
                                People who believed in us
                            </h3>
                            <p className="test1p">
                                Thank you for being a part of our journey .Grateful for your support and encouragement
                            </p>
                            {/* <button
                                className="custom-btn"
                                onClick={() => window.open("https://upload.picxy.com/login/", "_blank")}
                            >
                                Upload on Picxy
                            </button> */}
                        </div>
                        <div className="test1 car col-xl-6 col-md-6 col-sm-12">
                            <div id="testimonial-slider" className="owl-carousel">
                                {/* {testimonials.map((testimonial, index) => ( */}
                                <div className="testimonial-card">
                                    <img src="../static/img_new/quote.svg" style={{ width: '40px', height: '40px' }} />
                                    <p className="description">
                                        We have used Picxy.com and worked closely with the team. Not only does Picxy have a vast array of relevant stock images from India, they have also on many occasions undertaken photo shoots at a very short notice for account-related specific requirements.
                                    </p>
                                    <div className="d-flex align-items-center">
                                        <div className='me-2'>
                                            <img src="../static/img/photgraphers/ogilvy.jpg" className="user" />
                                        </div>
                                        <div>
                                            <h3 className="name">Rajeev Kondapalli</h3>
                                            <p className="designation">Business Head (Creative) - GroupM, Ogilvy</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="testimonial-card">
                                    <img src="../static/img_new/quote.svg" style={{ width: '40px', height: '40px' }} />

                                    <p className="description">
                                        We have been a customer of Picxy for more than a year now and have been using Picxy stock photos for our articles every day. Picxy is proactive in creating content for Indian content needs, all the way from farmers of India from all states to startups, brands & corporates.
                                    </p>

                                    <div className="d-flex align-items-center">
                                        <div className='me-2'>
                                            <img src="../static/img/photgraphers/the-news-minute.jpg" className="user" />
                                        </div>
                                        <div>
                                            <h3 className="name">Ram</h3>
                                            <p className="designation">Editor- TheNewsMinute</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="testimonial-card">
                                    <img src="../static/img_new/quote.svg" style={{ width: '40px', height: '40px' }} />
                                    <p className="description">
                                        We use @picxydotcom for our storytelling. It's quite a breather to find pictures like this below of a @swiggy in delivery boy to tell a good story. It never made sense to use pictures of foreigners to target an audience in India. TBH, We have seen higher engagement too.
                                    </p>
                                    <div className="d-flex align-items-center">
                                        <div className='me-2'>
                                            <img src="../static/img/photgraphers/accel.jpg" className="user" />
                                        </div>

                                        <div>
                                            <h3 className="name">Siddharth Ram</h3>
                                            <p className="designation">Head, FounderStack - Accel India</p>
                                        </div>
                                    </div>
                                </div>


                                {/* ))} */}
                            </div>
                        </div>
                    </div>
                </section>



                {/* <!---Client logos Starts----> */}
                <section className="container clientlogo">
                    <h3 className="clientlogoh3">Our Happy Customers</h3>
                    {/* <Clients /> */}

                    <div className="col-12">
                        <div id="clients-slider" className="owl-carousel">
                            <div className="block-1">
                            <img src="static/img/clients/google-logo.png" />
                                <img src="static/img/clients/Ogilvy@2x.jpg" />
                                <img src="static/img/clients/Thenewsminute@2x.jpg" />
                                <img src="static/img/clients/Pocketaces@2x.jpg" />
                                <img src="static/img/clients/Schbang@2x.jpg" />
                                <img src="static/img/clients/giveindia@2x.jpg" />
                                <img src="static/img/clients/Manmatters@2x.jpg" />
                                <img src="static/img/clients/Techstars@2x.jpg" />
                                <img src="static/img/clients/3one4capital@2x.jpg" />
                                <img src="static/img/clients/Accel@2x.jpg" />
                                <img src="static/img/clients/Thebetterindia@2x.jpg" />
                                <img src="static/img/clients/Thelogicalindian@2x.jpg" />
                                <img src="static/img/clients/Awaaz@2x.jpg" />
                                <img src="static/img/clients/Vahak@2x.jpg" />
                                <img src="static/img/clients/Vahan@2x.jpg" />
                                <img src="static/img/clients/The nudge@2x.jpg" />
                            </div>


                            <div className="block-1">
                            <img src="static/img/clients/Naandi@2x.jpg" />
                                <img src="static/img/clients/Sillymonks@2x.jpg" />
                                <img src="static/img/clients/Arka@2x.jpg" />
                                <img src="static/img/clients/Whitenoise@2x.jpg" />
                                <img src="static/img/clients/Alcrowd@2x.jpg" />
                                <img src="static/img/clients/Finwego@2x.jpg" />
                                <img src="static/img/clients/Tide@2x.jpg" />
                                <img src="static/img/clients/Livygo@2x.jpg" />
                                <img src="static/img/clients/Worknetwork@2x.jpg" />
                                <img src="static/img/clients/Deepsense@2x.jpg" />
                                <img src="static/img/clients/Bloggersmind@2x.jpg" />
                                <img src="static/img/clients/Vasty@2x.jpg" />
                                <img src="static/img/clients/Sacheerome@2x.jpg" />
                                <img src="static/img/clients/Thesis@2x.jpg" />
                                <img src="static/img/clients/Blueowl@2x.jpg" />
                                <img src="static/img/clients/gobiq-logo.png" />
                            </div>


                        </div>
                    </div>


                </section>
            </div>

            </>

        </LayoutBasic>

    }
}

export default withRouter(book_photographer);
